import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api, ApiError } from '../api/client.js';
import { useAuth } from '../auth/store.js';

export function AccountPage() {
  const { t } = useTranslation();
  const user = useAuth((s) => s.user);
  const setTokens = useAuth((s) => s.setTokens);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    if (newPassword !== confirmPassword) {
      setError(t('account.passwordMismatch'));
      return;
    }
    setBusy(true);
    try {
      const res = await api.changePassword({ currentPassword, newPassword });
      setTokens(res.accessToken, res.refreshToken);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setSuccess(true);
    } catch (err) {
      setError(
        err instanceof ApiError && err.status === 401
          ? t('account.wrongCurrentPassword')
          : t('account.changeFailed'),
      );
    } finally {
      setBusy(false);
    }
  }

  if (!user) return null;

  return (
    <div style={{ maxWidth: 420 }}>
      <h2>{t('account.title')}</h2>
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="muted">{t('auth.email')}</div>
        <div>{user.email}</div>
      </div>
      <form onSubmit={submit} className="card">
        <h3>{t('account.changePassword')}</h3>
        {error && <div className="error-banner">{error}</div>}
        {success && <div className="success-banner">{t('account.changeSuccess')}</div>}
        <div style={{ marginBottom: 12 }}>
          <label>{t('account.currentPassword')}</label>
          <input
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
            minLength={8}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>{t('account.newPassword')}</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={8}
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>{t('account.confirmPassword')}</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            minLength={8}
          />
        </div>
        <button type="submit" disabled={busy}>
          {t('account.changePassword')}
        </button>
      </form>
    </div>
  );
}
